define('Components/ProductListWidget/js/views/WithMediaProductListWidgetInstanceView',['jquery','WidgetInstanceView','app',
        'LazyLoad',
        'ProductBlockView',
        'template!Components/ProductListWidget/templates/with-media'],
    function($,WidgetInstanceView,app,
             LazyLoad,
             ProductBlockView ,
             withMediaTemplate){
    return WidgetInstanceView.extend({
        name:'ProductListWidgetInstanceView',
        events: {
            'mouseenter .products':'showProd',
            'mouseenter .media':'hideProd',
            'click .products .plus':'toggleProd'
        },
        setup:function(){
            var view = this,
                model = view.model;
            view.listenTo(model,'sync',view.onSyncDevatics);
            model.setupDevatics('dvt_await');
        },
        onSyncDevatics:function(model){
            this.preRender();
            this.render();
        },
        getTemplate:function(){
            return withMediaTemplate;
        },
        afterRender:function(){
            var self = this;
            self.attachViews(ProductBlockView.initializeProductBlocksOfView(self));
            self.listenTo(app,'change:scrollTop',self.onScroll);
            self.listenTo(app,'resize',self.onResize);
            setTimeout(function(){
                self.onResize();
            }, 1000);
            LazyLoad(self.$('.lazyload'));
        },
        showProd: function(){
            this.$('.media').addClass('inactive');
            this.$('.products').addClass('active');
            this.$('.products .plus').addClass('active');
        },
        hideProd: function(){
            this.$('.media, .products, .products .plus').removeClass('active inactive');
        },
        toggleProd: function(e){
            if($(e.currentTarget).hasClass('active')){
                this.hideProd();
            }else{
                this.showProd();
            }
        },
        onScroll: function(){
            var sel = this.$('.left-centered>div');
            if(!sel.hasClass('active')) {
                try {
                    if (app.get('scrollTop') > sel.offset().top - app.get('winH') + sel.height()) {
                        sel.addClass('active');
                    }
                }catch(err){console.warn(err)}
            }
        },
        onResize: function(){
            if(this.model.getMaxPerPage() == 6){
                var media = this.$('.media'),
                    products = this.$('.products');
                try{
                    media.css('width', products.offset().left)
                }catch (err){console.warn(err)}
            }
        }
    })
});
